import styles from './styles.module.scss';

type InputProps = {
  title: string;
  text: string;
};

export const StatusTooltipTemplate = ({ title, text }: InputProps) => {
  return (
    <div>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};
